import React from 'react';

import TravelTipsBlock from '../TravelTipsBlock/TravelTipsBlock';

import Props from './SidebarTravelTipsBlock.props';

const SidebarTravelTipsBlock = ({ topColumn, bottomColumn, ...TravelTipsProps }: Props) => {
  return (
    <TravelTipsBlock
      {...TravelTipsProps}
      firstColumn={topColumn}
      secondColumn={bottomColumn}
      titleStyle="FullWidth"
      column
    />
  );
};

export default SidebarTravelTipsBlock;
